import RewardData from '../components/store-data/RewardManager.json' assert {type: 'json'};

export type MalwearRewards = {
    transactionalStat: number;
    rewardName: string;
    spriteName: string;
    malWear: number;
};

export type RandomUnlockRewards = {
    transactionalStat: number;
    rewardObject: string;
    prerequisite: number;
    highAmount: number;
    rewardName: string;
    lowAmount: number;
    requirePrerequisite: boolean;
    isCoinReward: boolean;
    applyRewardToXP: boolean;
    implemented: boolean;
};

export class RewardManager {
    private static _instance: RewardManager;
    malwearRewards: MalwearRewards[];
    unlockRewards: RandomUnlockRewards[];

    static get instance(): RewardManager {
        if (!RewardManager._instance) {
            RewardManager._instance = new RewardManager();
        }
        return RewardManager._instance;
    }

    private constructor() {
        this.malwearRewards = RewardData.malwearRewards;
        this.unlockRewards = RewardData.unlockRewards;
    }
}
